

export const ParcelReceiptTemplate = `

<div class="A4 water-mark water-mark-ie" style="padding-bottom: 140px;">
<h2 contenteditable="false" style="text-align: center;"><strong>ใบตรวจรับการจัดซื้อ/จัดจ้าง</strong></h2>
<br/>
<div contenteditable="false" style="text-align: center;"><span style="text-align: center;" contenteditable="false" class="mom_date">{mom_date}</span></div>

<p style="padding-left: 80px;">&emsp;&emsp;</p>
<p style="padding-left: 80px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ตามหนังสือสัญญาข้อตกลง/ใบสั่ง 
<span data-template="true" class="requisitioner" contenteditable="false" >เลขที่</span>
<span data-template="true" class="po_no" contenteditable="false" >{po_no}</span> 
<span data-template="true" class="requisitioner" contenteditable="false" >ลงวันที่</span>
<span data-template="true" class="po_date" contenteditable="false" > {po_date} </span>
 บริษัท ปตท. จำกัด (มหาชน) ได้ตกลงจัดซื้อจัดจ้างกับ 
 <span data-template="true" contenteditable="false" class="vendor_name">{vendor_name}</span> สำหรับ 
 <span data-template="true" class="po_header" contenteditable="false" >{po_header}</span> นั้น</p>
<br />
<p style="padding-left: 80px;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;คู่สัญญาได้ส่งมอบ 
<span data-template="true" class="po_header" contenteditable="false"> {po_header}</span>
<span data-template="true" class="requisitioner" contenteditable="false">  งวดที่ </span>
<span data-template="true" class="period" contenteditable="false">{period}</span>
<span data-template="true" class="requisitioner" contenteditable="false"> เมื่อวันที่ </span>
<span data-template="true" class="completed_date" contenteditable="false">{completed_date}</span> ซึ่งคณะกรรมการตรวจรับได้ประชุมพิจารณาตรวจรับแล้ว ผลปรกฎว่า</p>


<p style="padding-left: 80px;" contenteditable="false">ผลการตรวจรับ</p>
<p style="padding-left: 80px;" contenteditable="false"><input class="mycheckbox" type="checkbox" id="headercomplete" name="headercomplete" checked='true'>ถูกต้อง</p>
<p style="padding-left: 120px;" contenteditable="false"><input type="checkbox" id="completed" name="completed" checked='true'> ครบถ้วนตามสัญญา</p>
<p style="padding-left: 120px;" contenteditable="false"><input type="checkbox" id="notcompleted" name="notcompleted" checked='false'> ไม่ครบถ้วนตามสัญญา</p>
<p style="padding-left: 80px;" contenteditable="false">ค่าปรับ</p>
<p style="padding-left: 120px;" contenteditable="false"><input type="checkbox" id="fine" name="fine" class="b_fine" checked='true'> มีค่าปรับ </p>
<p style="padding-left: 120px;" contenteditable="false"><input type="checkbox" id="notfine" name="notfine" class="b_nofine" checked=''> ไม่มีค่าปรับ</p>
<p style="padding-left: 500px;" contenteditable="false">คณะกรรมการตรวจรับสินค้า</p>
<p style="padding-left: 500px;" contenteditable="false" class="po_header"> {po_header}</p>

<br/>
<br/>
<p style="padding-left: 80px;" contenteditable="false">Electronically approved by Acceptance Committee </p>

</div>
<div class="footer"></div>
`
export const Data={
    "mom_date" : "08/09/2564",
    "po_no" : "",
    "po_date" : "",
    "vendor_name" : "",
    "po_header" : "",
    "period" : "",
    "completed_date": "01/09/2564" ,
}

export const ValideData={
    "curent_date" : 1,
    "po_no" : 2,
    "po_date" : 1,
    "venor_name" : 1,
    "po_detail" : 1,
    "period" : 1,
    "completed_date": 1,
}

